<script>
	import { createEventDispatcher } from "svelte";
	import {
		Button,
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
	} from "@sveltestrap/sveltestrap";
	import CustomSearch from "../../../components/CustomSearch/CustomSearch.svelte";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import { getWorkOrders } from "src/services/maintenanceRepair";

	export let isOpen = false;
	export let issue = null;
	export let vehicleId;
	export let currentWorkOrderId;

	const dispatch = createEventDispatcher();

	let mode = "create";
	let targetWorkOrderOption = null;
	let targetWorkOrderOptions = [];
	let error = "";

	async function loadTargetWorkOrders() {
		const res = await getWorkOrders(vehicleId, {});
		targetWorkOrderOptions = (res.data.items || [])
			.filter((order) => order.id !== currentWorkOrderId)
			.map((order) => ({ label: order.code, value: order.id }));
	}

	$: if (isOpen) {
		mode = "create";
		targetWorkOrderOption = null;
		error = "";
		loadTargetWorkOrders();
	}

	function close() {
		dispatch("close");
	}

	function confirm() {
		if (mode === "existing" && !targetWorkOrderOption) {
			error = "Select a work order before moving.";
			return;
		}

		dispatch("confirm", { issue, mode, targetWorkOrderOption });
	}
</script>

<Modal {isOpen} toggle={close} centered>
	<ModalHeader toggle={close}>Move issue to another work order</ModalHeader>
	<ModalBody>
		<ErrorMessageHandler message={error} />
		<p>Add issues to new or existing work order?</p>
		<div class="form-check mb-2">
			<input
				class="form-check-input"
				type="radio"
				name="moveToAnotherWorkOrderMode"
				id="move-create-new"
				value="create"
				bind:group={mode}
			/>
			<label class="form-check-label" for="move-create-new">
				Create new work order
			</label>
		</div>
		<div class="form-check mb-2">
			<input
				class="form-check-input"
				type="radio"
				name="moveToAnotherWorkOrderMode"
				id="move-add-existing"
				value="existing"
				bind:group={mode}
			/>
			<label class="form-check-label" for="move-add-existing">
				Add to existing work order
			</label>
		</div>

		{#if mode === "existing"}
			<label for="targetWorkOrder" class="d-block mt-3"
				>Search for an existing work order
			</label>
			<div id="targetWorkOrder">
				<CustomSearch
					items={targetWorkOrderOptions}
					placeholder="e.g. WO20260101_A123B"
					bind:value={targetWorkOrderOption}
					chevron
				/>
			</div>
		{/if}
	</ModalBody>
	<ModalFooter>
		<Button class="themeButton backButton" on:click={close}>Cancel</Button>
		<Button class="themeButton primary" on:click={confirm}>Move</Button>
	</ModalFooter>
</Modal>
